// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getSafeGatewayVoucherCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { formatCashCode } from '@tectonics/prs/cash-mexico';

export function PagosnetNumber(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <>
      <Description>
        Usa esto número de recaudación para realizar tu pago:
      </Description>
      <div style={{
        fontSize: '20px',
        fontWeight: 700,
        color: '#737f93',
      }}>
        {formatCashCode(getSafeGatewayVoucherCode(incomingPayment))}
      </div>
    </>
  );
}

const Description = styled.div`
  color: #737f93;
  font-size: 18px;
  font-family: ${props => props.theme.fontFamily.display};
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.5em;
`;
